<template>
  <div>
    <!-- <button class="toastTest" @click="testToast">Test toast</button> -->
    <div class="toastContainer">
      <div
        v-for="toast in toasts"
        :key="toast.id"
        :class="['toast', toast.type]"
        v-on:click="removeToast(toast.id)"
      >
        {{ toast.message }}
      </div>
    </div>
  </div>
</template>

<script>
import useToast from "@/hooks/useToast";

export default {
  setup() {
    const toasts = useToast.getToasts();
    let cnt = 0;

    const testToast = () => {
      useToast.addSuccess("Действие выполнено успешно! - " + cnt++);
      if (Math.random() > 0.5) {
        useToast.addError("Ошибка выполнения действия! - " + cnt++);
      }
    };

    const removeToast = (id) => {
      const index = toasts.value.findIndex((t) => t.id === id);
      if (index !== -1) {
        toasts.value.splice(index, 1);
      }
    }

    return {
      toasts,
      testToast,
      removeToast
    };
  },
};
</script>

<style scoped>
button.toastTest {
  position: fixed;
  left: 8px;
  top: 8px;
  z-index: 100;
  padding: 8px 16px;
  border-radius: 4px;
  background-color: #333;
  color: white;
  border: none;
  outline: none;
  cursor: pointer;
  /* transition: opacity 0.3s ease; */
  /* opacity: 0.85; */
}

.toastContainer {
  position: fixed;
  min-width: 20%;
  bottom: 48px;
  right: 32px;
  z-index: 10000;
}

.toast {
  /* position: relative; */
  background-color: #cccccc;
  color: rgb(63, 63, 63);
  font-size: 85%;
  padding: 8px 16px;
  border-radius: 3px;
  transition: opacity 0.3s ease;
  margin-bottom: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.toast:hover {
  cursor: crosshair;
}

.toast.success {
  background-color: #9dc2ec;
  color: rgb(63, 63, 63);
}

.toast.error {
  background-color: #eef7bd;
  color: rgb(63, 63, 63);
}

.toast-hide {
  display: none;
}
</style>